import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import {
    getExhVendorConfigurationListUrl, insertUpdateExhVendorConfigurationUrl, deleteExhVendorConfigurationUrl,
    GET_EXH_VENDOR_CONFIGURATION_LIST, INSERT_UPDATE_EXH_VENDOR_CONFIGURATION, DELETE_EXH_VENDOR_CONFIGURATION,getVendorMasterListUrl,GET_VENDOR_MASTER_LIST, headers
} from "../../../../utils/constants";

export const getVendorConfigurationList_action = (ExihibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
        }

        const res = await axiosGet(getExhVendorConfigurationListUrl, params, headers)

        dispatch({
            type: GET_EXH_VENDOR_CONFIGURATION_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getVendorMasterList_action = (ExihibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
        }

        const res = await axiosGet(getVendorMasterListUrl, params, headers)

        dispatch({
            type: GET_VENDOR_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateVendorConfiguration_action = (VendorConfigurationID, ExihibitionID, Title, File, FileType, FilePath, RecipientMappings) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            VendorConfigurationID: VendorConfigurationID,
            ExhibitionID: ExihibitionID,
            Title: Title,
            File: File,
            FileType: FileType,
            FilePath: FilePath,
            RecipientMappings: RecipientMappings != null ? RecipientMappings : [],
        }

        const res = await axiosPost(insertUpdateExhVendorConfigurationUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_EXH_VENDOR_CONFIGURATION,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteVendorConfiguration_action = (ExihibitionID, VendorConfigurationID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            VendorConfigurationID: VendorConfigurationID,
        }

        const res = await axiosPost(deleteExhVendorConfigurationUrl, params, headers)

        dispatch({
            type: DELETE_EXH_VENDOR_CONFIGURATION,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}
